<template>
    <div class="row folded-corner-parent">
        <div class="fictional-client2">
            <div class="container-section">
                <img class="image-container img-content-dbf415fc" />
                <div class="container-subsection">
                    <img class="image-container img-content-142be835" />
                </div>
            </div>
            <div class="future-container">
                <img class="image-container img-content-8a201692" />
            </div>
            <div class="fictional-client">
                <p class="caption">Welkom!</p>
                <p class="fictional-client-text">
                    Wij zijn een fictieve woningcorporatie in de regio {{ CityName }}. Met ruim 10.000 woningen zetten wij ons
                    elke dag in voor prettig, betaalbaar en veilig wonen – in de stad én in en om de dorpen.
                    <br />
                    <br />
                    Van vooroorlogse grondgebonden woningen tot moderne appartementen en zorgvastgoed: ons
                    bezit is divers, net als de mensen voor wie wij werken. Onze huurders staan centraal in
                    alles wat wij doen.
                </p>
                <ButtonView text="Over ons" background="bright" style="float: right;" @click="buttonClicked" />
            </div>
        </div>

        <img src="@/assets/corner.png" class="folded-corner" />
    </div>
</template>

<script>
import ButtonView from '@/components/ButtonView.vue';
import constants from '@/constants.js';

export default {
    name: 'HomeBlockPhotos',
    components: {
        ButtonView,
    },
    data() {
        return {
            CityName: constants.CityName
        };
    },
    methods: {
        buttonClicked() {
            this.$router.push('/over-ons');
        },
    },
};
</script>

<style scoped>
.folded-corner {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100px;
    padding-right: 0
}

.folded-corner-parent {
    position: relative;
}

.container-section {
    box-sizing: border-box;
    flex: 0 0 auto;
    padding-top: 50px;
    padding-bottom: 12.5px;
}

.img-content-dbf415fc {
    content: url("@/assets/front_6.jpg");
}

.img-content-142be835 {
    content: url("@/assets/front_7.jpg");
}

.img-content-8a201692 {
    content: url("@/assets/front_2.jpg");
    height: 258px;
    border: 0.8rem solid rgb(251, 250, 249) !important;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.2);
    transform: rotate(-6deg) scale(1.15) translate(-0.4rem, 0);
}

.container-subsection {
    box-sizing: border-box;
    margin-top: 30px;
}

.image-container {
    box-sizing: border-box;
    display: block;
    width: 200px;
    max-width: initial;
    border: none;
    object-fit: cover;
}

.future-container {
    box-sizing: border-box;
    flex: 0 0 auto;
    padding-top: 80px;
    padding-bottom: 72px;
}

.fictional-client {
    box-sizing: border-box;
    flex: 0 1 auto;
    align-self: flex-start;
}

.fictional-client2 {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    gap: 30px;
    align-items: center;
    justify-content: flex-end;
    /* max-width: 1170px; */
    padding: 30px 71px 39px;
    background: var(--color-primary-extra-light);
    align-items: flex-start;
}

.fictional-client-text {
    box-sizing: border-box;
    margin-top: 12px;
}
</style>
